import { useEffect, useState } from "react";

/** Position a rail flyout panel with `position: fixed` so it is not clipped by workspace overflow. */
export function useRailFlyoutPosition(open, anchorRef) {
  const [style, setStyle] = useState(null);

  useEffect(() => {
    if (!open || !anchorRef?.current) {
      setStyle(null);
      return undefined;
    }

    const update = () => {
      const anchor = anchorRef.current;
      if (!anchor) return;

      const rect = anchor.getBoundingClientRect();
      const width = Math.min(300, Math.max(220, window.innerWidth - rect.right - 14));
      const maxHeight = Math.min(420, window.innerHeight - 16);
      const top = Math.min(
        Math.max(8, rect.top),
        window.innerHeight - maxHeight - 8,
      );

      setStyle({
        position: "fixed",
        left: rect.right + 6,
        top,
        width,
        maxHeight,
        zIndex: 2060,
      });
    };

    update();
    window.addEventListener("resize", update);
    window.addEventListener("scroll", update, true);
    return () => {
      window.removeEventListener("resize", update);
      window.removeEventListener("scroll", update, true);
    };
  }, [open, anchorRef]);

  return style;
}
